import $2 from "jquery";
window.$2 = $2;
import 'simplebar/dist/simplebar.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick';

"use strict";

$(document).ready(function () {
  $('.slider--howto').on('init', function(event, slick) {
    $('.slider--howto img').css({
      'cursor': 'pointer'
    }).off('click').on('click', function () {
      $('.slider--howto').slick('slickNext');
    })
  })
  $('.s-drinks .slider').on('init', function(event, slick) {
    $('.s-drinks .slider .drink__image').css({
      'cursor': 'pointer'
    }).off('click').on('click', function () {
      $('.s-drinks .slider').slick('slickNext');
    })
  })
  $('[data-slick]').slick();

    $('.contest-recipe-slider').slick({
        dots: true,
        arrows: false,
        initialSlide: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    dots: false,
                    arrows: true,
                }
            },
        ]
    });

    $(window).on('resize', function () {
        if ($(window).innerWidth() <= 991) {
            if (!$('.contest-how-list').hasClass("slick-initialized")) {
                $('.contest-how-list').slick({
                    dots: false,
                    arrows: true,
                });
            }
        } else {
            if ($('.contest-how-list').hasClass("slick-initialized")) {
                $('.contest-how-list').slick('unslick');
            }
        }
    }).trigger('resize');
});
